// Fehlermeldungen rund um Anmeldung und Konto in verständlichem Deutsch.
//
// `request()` wirft `Error("<status> <body>")`; bei 401 nur "unauthorized".
// Die API schickt zu den meisten Fehlern schon einen deutschen Satz mit – den
// nehmen wir. Das Rate-Limit von Fastify antwortet dagegen englisch.

export function kontoFehler(err: unknown, beiFalschemLogin = "E-Mail oder Passwort falsch."): string {
  const raw = err instanceof Error ? err.message : String(err);
  if (raw === "unauthorized" || raw.startsWith("401")) return beiFalschemLogin;
  const status = Number(raw.slice(0, 3));
  let body: { error?: string; message?: string } = {};
  try {
    body = JSON.parse(raw.slice(4)) as typeof body;
  } catch {
    /* kein JSON */
  }
  if (status === 429 && body.error !== "too_many_attempts") {
    return "Zu viele Versuche in kurzer Zeit. Bitte in einer Viertelstunde noch einmal.";
  }
  if (body.message) return body.message;
  // h-ui: Radio vom Betreiber gesperrt – falls die API keinen Satz mitschickt.
  if (status === 423) return "Dieses Radio ist vorübergehend gesperrt. Bitte wende dich an den Betreiber.";
  if (raw.startsWith("Failed to fetch") || raw.includes("NetworkError")) return "Die Suite ist gerade nicht erreichbar.";
  return "Das hat nicht geklappt. Bitte noch einmal versuchen.";
}
